import { Link, createFileRoute, redirect } from '@tanstack/react-router'
import { ManageLabelsList } from './-components/ManageLabelsList'
import { PageTitle } from '@/components/PageTitle'
import { Department } from '@/types/user.types'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'

export const Route = createFileRoute('/_app/backoffice/labels/')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    const { isAuthenticated, isLoading, departmentResolved, user } =
      context.auth
    if (!isAuthenticated && !isLoading) {
      throw redirect({ to: '/login' })
    }
    // Only redirect once the department is actually resolved and known to be
    // non-admin — checking too early bounces admins to /home on a cold
    // refresh/deep-link (department loads from a backend fetch after Keycloak
    // init). While unresolved, the server-side @RequireAdmin guard enforces access.
    if (departmentResolved && user && user.department !== Department.ADMIN) {
      throw redirect({ to: '/home' })
    }
  },
})

function RouteComponent() {
  return (
    <div className="py-4">
      <PageTitle title="Labels" />

      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/backoffice">Backoffice</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Labels</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="mb-4">
        <h1 className="text-3xl font-bold tracking-tight">Labels</h1>
        <p className="text-muted-foreground mt-2">
          Rename, recolor, or delete team-wide forecast labels. Planners create
          and assign labels from the forecast label picker.
        </p>
      </div>

      <ManageLabelsList />
    </div>
  )
}
